<template>
  <common-dialog ref="dialog" width="550px" title="添加发货地址" id-key="id" :data="data" @opened="onOpened"
    @create-opened="onCreateOpened" @edit-opened="onEditOpened" :form-rules="rules" :save-func="saveDataFunc"
    @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="快递公司" prop="aliLogisticId">
        <div class="sync-select">
          <el-select v-model="data.aliLogisticId" filterable placeholder="请选择">
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.companyName" :value="i.id"></el-option>
          </el-select>
          <el-button class="refresh-btn" icon="el-icon-refresh" @click="syncLogistic"></el-button>
        </div>
      </el-form-item>
      <el-form-item label="发货地址" prop="aliAddressId">
        <div class="sync-select">
          <el-select v-model="data.aliAddressId" placeholder="请选择" @change="onAddressChange">
            <el-option v-for="(i, k) in senderAddresses" :key="k" :label="i.address" :value="i.id"></el-option>
          </el-select>
          <el-button class="refresh-btn" icon="el-icon-refresh" @click="syncAddress"></el-button>
        </div>
      </el-form-item>
      <el-form-item label="寄件人" prop="sendGoodsContactor">
        <el-input v-model="data.sendGoodsContactor" disabled placeholder="请输入寄件人"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input v-model="data.mobile" disabled placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-checkbox v-model="data.senderAddress.dataMasking">打印发件人手机号脱敏显示，例如：13*********34</el-checkbox>
      </el-form-item> -->
      <el-form-item label="固定号码" prop="phone">
        <el-input v-model="data.phone" disabled placeholder="请输入固定号码"></el-input>
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button type="warning" @click="reset">重 置</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      aliApi: {
        logistics: require('@/api/ali/logistics').default,
      },
      sysType: "",
      mallToken: "", //店铺Token
      data: {
        id: 0,
        aliLogisticId: "",
        aliAddressId: "",
        sendGoodsContactor: "",
        mobile: "",
        phone: "",
      },
      mallList: [],
      initData: {},
      rules: {
        aliLogisticId: [{ required: true, message: '请选择快递公司' }],
        aliAddressId: [{ required: true, message: '请选择发货地址' }],
      },
      companiesList: [],
      senderAddresses: [],
    };
  },
  mounted() { },
  methods: {
    onOpened() {
      console.log("onOpened")
      this.sysType = "ali"; //localStorage.getItem("sys_type");
      // this.mallList = JSON.parse(localStorage.getItem("mall_list"));
      // this.mallToken = localStorage.getItem("token");

      this.$refs.dialog.isLoading = true;
      var promises = [this.getCompanies(), this.getAddress()];
      Promise.all(promises).then(res => {
        this.$refs.dialog.isLoading = false;
      }).catch(error => {
        this.$refs.dialog.isLoading = false;
      });
    },
    onCreateOpened() {
      this.isEdit = false;
      this.initData = { ...JSON.parse(JSON.stringify(this.data)) };
    },
    onEditOpened() {
      this.isEdit = true;
      console.log("onEditOpened", JSON.parse(JSON.stringify(this.data)))
      // var x = this.data.senderAddress;
      // this.data.address = x.country + x.province + x.city + x.district + x.detailAddress;
      this.initData = { ...JSON.parse(JSON.stringify(this.data)) }
    },
    getCompanies() {
      console.log("获取物流公司")
      return new Promise((resolve, reject) => {
        this.companiesList = [];
        // this.$refs.dialog.isLoading = true;
        this[this.sysType + "Api"].logistics.getLogistics().then(res => {
          // this.$refs.dialog.isLoading = false;
          if (res.errorMessage) {
            this.$message.error(res.errorMessage);
          } else {
            this.companiesList = res;
          }
          resolve(res)
        }).catch((err) => {
          // this.$refs.dialog.isLoading = false;
          reject(err)
        })
      });
    },
    getAddress() {
      return new Promise((resolve, reject) => {
        this.senderAddresses = [];
        this[this.sysType + "Api"].logistics.getAddress().then(res => {
          if (res.errorMessage) {
            this.$message.error(res.errorMessage);
          } else {
            this.senderAddresses = res.map(x => {
              return {
                ...x,
                address: x.fullAddress.replaceAll("^^^", "")
              }
            });
          }
          console.log("this.senderAddresses", this.senderAddresses);
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    syncAddress() {
      this.$refs.dialog.isLoading = true;
      this[this.sysType + "Api"].logistics.syncAddress().then(res => {
        this.getAddress();
        this.$refs.dialog.isLoading = false;
      }).catch(err => {
        this.$refs.dialog.isLoading = false;
      })
    },
    syncLogistic() {
      this.$refs.dialog.isLoading = true;
      this[this.sysType + "Api"].logistics.sync().then(res => {
        this.getSyncState();
      }).catch(err => {
        this.$refs.dialog.isLoading = false;
      })
    },
    getSyncState() {
      // 0：空闲，无抓取任务
      // 1：正在抓取中
      // 2：抓取已完成，成功
      // 3：抓取已中止，失败
      var interval = setInterval(() => {
        this[this.sysType + "Api"].logistics.syncStatus().then(res => {
          if (res.syncStatus != 1) {
            clearInterval(interval);
            this.$refs.dialog.isLoading = false;
            if (res.syncStatus == 2) {
              this.$message.success("抓取完成");
              this.getCompanies();
            }
            if (res.syncStatus == 3) this.$message.error("抓取失败，已终止");
          }
        }).catch(err => {
          clearInterval(interval);
          this.$refs.dialog.isLoading = false;
        })
      }, 5000);
    },
    onAddressChange(e) {
      console.log("change", e);
      var addr = this.senderAddresses.find(x => x.id == e);
      console.log("addr", addr);
      this.data.sendGoodsContactor = addr.sendGoodsContactor;
      this.data.mobile = addr.mobile;
      this.data.phone = addr.phone;
    },
    reset() {
      if (this.$refs.dialog.isLoading) {
        this.$message.warning("正在加载中，请稍候");
        return;
      }
      console.log("重置", this.initData);
      this.data = { ...this.initData }
      this.$refs.dialog.isChange = false;
      this.$refs.dialog.clearValidate();
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        var func = this[this.sysType + "Api"].logistics.postSendaddress;
        if (this.data.id != 0) {
          func = this[this.sysType + "Api"].logistics.putSendaddress;
        }
        func(this.data).then(res => {
          if (res) this.data.id = res;
          resolve({ Code: 0, Msg: null });
        }).catch(err => {
          resolve({ Code: 1, Msg: res.errorMessage });
        })
      })
    },
    onClosed() {
      var resetData = this.$options.data().data;
      this.data = { ...resetData }
      this.companiesList = [];
      this.senderAddresses = [];
      this.$refs.dialog.clearValidate();
    }
  },
};
</script>
<style lang="scss" scoped>
.sync-select {
  display: flex;

  .el-select {
    width: calc(100% - 55px);
  }

  .refresh-btn {
    margin-left: 5px;
    width: 50px;
    border-radius: 4px;
  }
}
</style>